import React, { useState } from 'react';
import { Form, Input, Col, Row } from 'antd';
import { FormInstance } from 'antd/lib/form';
import FormInput from 'components/FormInput';
import TaxSelect from 'components/TaxSelect';
import ParListSelect from 'components/ParListSelect';
import { shouldUpdateCompare } from 'utils/utils2';
import Title from 'components/Title';
import Address from 'components/theme_components/ThirdParty/address';
import AddressTest from 'components/theme_components/ThirdParty/address/AddresseSFS';
import AddressSFS from 'components/theme_components/ThirdParty/address/AddresseSFS';
export type GeneralDataSuperTPProps = {
  form: FormInstance;
  required: boolean;
};

const GeneralDataSuperTP = ({ form, required }: GeneralDataSuperTPProps) => {
  const [paymentDelegation, setPaymentDelegation] = useState<boolean | null>(null);

  return (
    <>
      <Row gutter={16} justify="space-evenly">
        <FormInput col xs={24} md={24} style={{ marginBottom: '30px' }} name="tpname" rules={[{ required: true }]} />
        <FormInput col xs={24} md={24} style={{ marginBottom: '30px' }} name="tpmainadrstreet1" rules={[{ required: true }]} />
        <FormInput col xs={24} md={24} style={{ marginBottom: '30px' }} name="tpmainadrstreet2" />
        <FormInput col xs={24} md={24} style={{ marginBottom: '30px' }} name="tpmainadrstreet3" />
        <AddressSFS
          form={form}
          codePostalField="tpmainadrzipcode"
          paysField="tpmainadrcountry"
          regionField="tpmainadrregion"
          villeField="tpmainadrcity"
          colU={24}
          hideRegionGlobal
          hideRegion
          Colw={localStorage.getItem('lancode') === 'FR' ? { span: 6 } : { span: 6 }}
          spanCountry={6}
          spanZip={6}
          spanCity={17}
          cityRequired
          countryRequired
          zipcodeRequired
        />
      </Row>
    </>
  );
};

export default GeneralDataSuperTP;
